var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "ruleForm",
      staticClass: "demo-ruleForm",
      attrs: { model: _vm.ruleForm }
    },
    [
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", {}, [_vm._v("申请描述")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.applyDesc))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("审核操作")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "auditState" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.setAuditState },
                      model: {
                        value: _vm.ruleForm.auditState,
                        callback: function($$v) {
                          _vm.$set(_vm.ruleForm, "auditState", $$v)
                        },
                        expression: "ruleForm.auditState"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("同意")
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "-1" } }, [
                        _vm._v("拒绝")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.ruleForm.auditState == 1 && false
          ? _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v(" ")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "auditState" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.ruleForm.autoClearFlag,
                            callback: function($$v) {
                              _vm.$set(_vm.ruleForm, "autoClearFlag", $$v)
                            },
                            expression: "ruleForm.autoClearFlag"
                          }
                        },
                        [_vm._v("自动清除")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", {}, [_vm._v("原因")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "desc" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.ruleForm.auditDesc,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "auditDesc", $$v)
                      },
                      expression: "ruleForm.auditDesc"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b0cfe9c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0cfe9c8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/assetFiscal/AssetFiscalClearVoucherAudit.vue
// module id = 2628
// module chunks = 0